import {
  WorkItemServiceProvider,
  vsProviderName as WorkItemServiceProviderName,
} from "../";
import { OptionController } from "./optionController";

optionConfig.$inject = ["formlyConfigProvider", WorkItemServiceProviderName];
export function optionConfig(
  formlyConfigProvider: AngularFormly.IFormlyConfig,
  workItemServiceProvider: WorkItemServiceProvider
) {
  workItemServiceProvider.addWorkItemType({
    name: "Option",
    formlyFieldType: "processOption",
  });

  formlyConfigProvider.setType({
    name: "processOption",
    template: require("!html-loader!./index.html").default,
    controller: OptionController,
  });
}
